import { Grid } from '@material-ui/core';
import { Work, WorkOutline } from '@material-ui/icons';
import {
  createNumberFormatField,
  createSelectField,
  createTextField,
} from '@roc/ui';
import { rentalExperienceOptionsWithText } from 'libs/feature-borrower-loan-submission/src/modules/newLoanApplication/utils/loanApplicationConstants';
import { observer } from 'mobx-react';
import { useLoanTypeStore } from '../../../hooks/useLoanTypeStore';
import { FORM_MAX_WIDTH } from '../../../utils/constants';
import { EntityInformationForm } from './entityInformationForm';
import { OneToolCard } from './oneToolCard';

export const FicoAndExperienceCard = observer(() => {
  const { loanTypeStore } = useLoanTypeStore();
  const { borrowerInformationStore } = loanTypeStore;
  const { mainBorrowerFormStore } = borrowerInformationStore;
  return (
    <OneToolCard
      maxWidth={FORM_MAX_WIDTH}
      icon={WorkOutline}
      title={'Your Credit and Background'}
    >
      <Grid container spacing={2} justifyContent='center'>
        <Grid item xs={8}>
          {createNumberFormatField({
            label: 'Estimated FICO',
            fieldName: 'ficoProvidedAtOrigination',
            testId: 'ficoProvidedAtOrigination',
            store: mainBorrowerFormStore,
            standaloneLabel: false,
            onChange: value =>
              mainBorrowerFormStore.onFieldChange(
                'ficoProvidedAtOrigination',
                value ? parseInt(value) : ''
              ),
          })}
        </Grid>
        <Grid item xs={8}>
          {createSelectField({
            testId: 'rentalExperience',
            fieldName: 'rentalExperience',
            store: mainBorrowerFormStore,
            label: 'Tell us about your investment experience',
            options: rentalExperienceOptionsWithText,
          })}
        </Grid>
      </Grid>
    </OneToolCard>
  );
});
